import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // useEffect(() => {
  //   const currentLang = i18n.language;
  //   const direction = currentLang === "ar" ? "rtl" : "ltr";
  //   document.documentElement.setAttribute("dir", direction);
  //   document.documentElement.setAttribute("lang", currentLang);
  // }, [i18n.language]);

  return (
    <>
      <div className="privacy-bg from-top">
        <Header />

        <div className="heading-policy flex-column">
          <h1 className="text-white">Privacy Policy</h1>
        </div>
      </div>

      <div className="container data-info">
        <div className="text-center" style={{ color: "#E5E5E5" }}>
          <p>Last Updated: 14 November 2025</p>
          <p>
            Company Name: Global Arabian Trading LLC-FZ
          </p>
          <p>
            Website: <a href="https://globalarabiantrading.com/" style={{ color: "#4A90E2" }}> https://globalarabiantrading.com/ </a>
          </p>
          <p>
            Email: <a href="mailto:Customerservice@globalarabiantrading.com" style={{ color: "#4A90E2" }}>Customerservice@globalarabiantrading.com</a>
          </p>
        </div>
        <div className="privacy-heading">
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>1. Introduction</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            Global Arabian Trading LLC-FZ ("we", "us", "our") is committed to protecting your privacy and ensuring that your personal information is handled responsibly. This Privacy Policy explains how we collect, use, store, and safeguard your information when you visit or interact with our website https://globalarabiantrading.com/.
          </p>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }} className="mt-4 mb-5">
            By using our website, you agree to the collection and use of information in accordance with this Privacy Policy.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>2. Information We Collect</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            <strong>A. Personal Information</strong>
          </p>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We may collect personal information that you voluntarily provide to us, such as:
          </p>
          <ul style={{ color: "#E5E5E5" }}>
            <li style={{ color: "#E5E5E5" }}>Full name</li>
            <li style={{ color: "#E5E5E5" }}>Email address</li>
            <li style={{ color: "#E5E5E5" }}>Phone number</li>
            <li style={{ color: "#E5E5E5" }}>Company name</li>
            <li style={{ color: "#E5E5E5" }}>Any information submitted through contact forms or communication channels</li>
          </ul>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            <strong>B. Automatically Collected Data</strong>
          </p>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We may also collect data automatically, including:
          </p>
          <ul style={{ color: "#E5E5E5" }}>
            <li style={{ color: "#E5E5E5" }}>IP address</li>
            <li style={{ color: "#E5E5E5" }}>Browser type</li>
            <li style={{ color: "#E5E5E5" }}>Device type</li>
            <li style={{ color: "#E5E5E5" }}>Pages visited</li>
            <li style={{ color: "#E5E5E5" }}>Usage data and analytics</li>
            <li style={{ color: "#E5E5E5" }}>Cookies and tracking technologies</li>
          </ul>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>3. How We Use Your Information</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We use the collected information to:
          </p>
          <ul style={{ color: "#E5E5E5" }}>
            <li style={{ color: "#E5E5E5" }}>Respond to your inquiries</li>
            <li style={{ color: "#E5E5E5" }}>Provide customer support</li>
            <li style={{ color: "#E5E5E5" }}>Improve website performance and user experience</li>
            <li style={{ color: "#E5E5E5" }}>Share updates about our services</li>
            <li style={{ color: "#E5E5E5" }}>Process business communications</li>
            <li style={{ color: "#E5E5E5" }}>Analyze website traffic and usage</li>
            <li style={{ color: "#E5E5E5" }}>Maintain security</li>
          </ul>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>4. Legal Basis for Processing (Where Applicable)</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            For users in regions such as the EU (GDPR), personal data may be processed based on:
          </p>
          <ul style={{ color: "#E5E5E5" }}>
            <li style={{ color: "#E5E5E5" }}>Consent</li>
            <li style={{ color: "#E5E5E5" }}>Contractual necessity</li>
            <li style={{ color: "#E5E5E5" }}>Legal obligations</li>
            <li style={{ color: "#E5E5E5" }}>Legitimate business interests</li>
          </ul>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>5. Cookies and Tracking Technologies</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We may use cookies and similar technologies to improve user experience and gather analytics. You may disable cookies through your browser, but doing so may affect certain website functions.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>6. How We Share Your Information</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We do not sell or rent your personal data. We may share information with:
          </p>
          <ul style={{ color: "#E5E5E5" }}>
            <li style={{ color: "#E5E5E5" }}>Trusted service providers (hosting, analytics, IT support)</li>
            <li style={{ color: "#E5E5E5" }}>Legal authorities when required</li>
            <li style={{ color: "#E5E5E5" }}>Business partners only with your permission</li>
          </ul>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>7. Data Storage and Security</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We use reasonable security measures to protect your data from unauthorized access, misuse, or loss. However, no method of online transmission is completely secure.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>8. Data Retention</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We retain your information only as long as necessary to fulfill the purposes stated in this policy, unless a longer retention period is required by law. Afterward, data is securely deleted or anonymized.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>9. Your Rights</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            Depending on your region, you may have the right to:
          </p>
          <ul style={{ color: "#E5E5E5" }}>
            <li style={{ color: "#E5E5E5" }}>Access your personal data</li>
            <li style={{ color: "#E5E5E5" }}>Request correction or deletion</li>
            <li style={{ color: "#E5E5E5" }}>Withdraw consent</li>
            <li style={{ color: "#E5E5E5" }}>Restrict processing</li>
            <li style={{ color: "#E5E5E5" }}>Request data portability</li>
            <li style={{ color: "#E5E5E5" }}>Object to certain forms of processing</li>
          </ul>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            To exercise your rights, contact us at <a href="mailto:Customerservice@globalarabiantrading.com" style={{ color: "#4A90E2" }}>Customerservice@globalarabiantrading.com</a>.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>10. Third-Party Websites</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            Our website may contain links to third-party sites. We are not responsible for their content or privacy practices. Please review their policies separately.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>11. Children's Privacy</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            Our services are not intended for individuals under 18. We do not knowingly collect personal information from minors.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>12. International Data Transfers</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            Your information may be transferred to servers outside your country. We take steps to ensure adequate protection during such transfers.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>13. Changes to This Privacy Policy</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            We may update this Privacy Policy from time to time. Updates will be reflected with a new "Last Updated" date. We encourage you to review the policy periodically.
          </p>
          
          <h3 className="mt-5" style={{ color: "#E5E5E5" }}>14. Contact Us</h3>
          <p style={{ textAlign: "justify", color: "#E5E5E5" }}>
            For questions or privacy-related requests, contact us:
          </p>
          <p style={{ color: "#E5E5E5" }}>
            <strong>Contact Details:</strong>
          </p>
          <p style={{ color: "#E5E5E5" }}>
            <strong>UAE:</strong> <a href="tel:+971542210088" style={{ color: "#4A90E2" }}>+971 54 22 100 88</a>
          </p>
          <p style={{ color: "#E5E5E5" }}>
            <strong>Denmark:</strong> <a href="tel:+4527599957" style={{ color: "#4A90E2" }}>+45 27599957</a>
          </p>
          <p style={{ color: "#E5E5E5" }}>
            <a href="mailto:Customerservice@globalarabiantrading.com" style={{ color: "#4A90E2" }}>Customerservice@globalarabiantrading.com</a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default PrivacyPolicy;